import { Shimmer } from '@components';

import { Container } from './ProductList.styles';

export const ProductListLoading = () => {
  return (
    <Container>
      <Shimmer
        style={{
          height: 32,
          width: '100%',
          borderRadius: 4,
          marginTop: 16,
          marginBottom: 16,
        }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
      <Shimmer
        style={{
          height: 32,
          width: '100%',
          borderRadius: 4,
          marginTop: 16,
          marginBottom: 16,
        }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
      <Shimmer
        style={{
          height: 32,
          width: '100%',
          borderRadius: 4,
          marginTop: 16,
          marginBottom: 16,
        }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
      <Shimmer
        style={{
          height: 32,
          width: '100%',
          borderRadius: 4,
          marginTop: 16,
          marginBottom: 16,
        }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
    </Container>
  );
};
